import './page';
import './view';
import './component/prems-discount-category-selector';
import './component/prems-discount-customer-group-selector'
import './component/prems-discount-sales-channel-selector';
import './component/prems-discount-promotion-selector';
import './component/prems-discount-customer-selector';
import './component/prems-info-banner';

Shopware.Module.register('prems-discount-category', {
    type: 'plugin',
    name: 'Discount category',
    title: 'prems-discount-category.general.moduleTitle',
    description: 'prems-discount-category.general.moduleDescription',
    color: '#FFD700',
    icon: 'regular-shopping-cart',

    routes: {
        list: {
            component: 'prems-discount-category-list',
            path: 'list'
        },
        detail: {
            component: 'prems-discount-category-detail',
            path: 'detail/:id',
            props: {
                default: (route) => ({discountCategoryId: route.params.id})
            },
            redirect: {
                name: 'prems.discount.category.detail.base',
            },
            children: {
                base: {
                    component: 'prems-discount-category-detail-base',
                    path: 'base',
                    meta: {
                        parentPath: 'prems.discount.category.list',
                    },
                },
                discount: {
                    component: 'prems-discount-category-detail-discount',
                    path: 'discount',
                    meta: {
                        parentPath: 'prems.discount.category.list',
                    },
                },
                restriction: {
                    component: 'prems-discount-category-detail-restriction',
                    path: 'restriction',
                    meta: {
                        parentPath: 'prems.discount.category.list',
                    },
                },
                statistics: {
                    component: 'prems-discount-category-detail-statistics',
                    path: 'statistics',
                    meta: {
                        parentPath: 'prems.discount.category.list',
                    },
                }
            },
        },
        create: {
            component: 'prems-discount-category-detail',
            path: 'create',
            redirect: {
                name: 'prems.discount.category.create.base',
            },
            meta: {
                parentPath: 'prems.discount.category.list'
            },
            children: {
                base: {
                    component: 'prems-discount-category-detail-base',
                    path: 'base',
                    meta: {
                        parentPath: 'prems.discount.category.list',
                    },
                },
                discount: {
                    component: 'prems-discount-category-detail-discount',
                    path: 'discount',
                    meta: {
                        parentPath: 'prems.discount.category.list',
                    },
                },
                restriction: {
                    component: 'prems-discount-category-detail-restriction',
                    path: 'restriction',
                    meta: {
                        parentPath: 'prems.discount.category.list',
                    },
                },
                statistics: {
                    component: 'prems-discount-category-detail-statistics',
                    path: 'statistics',
                    meta: {
                        parentPath: 'prems.discount.category.list',
                    },
                }
            }
        }
    },

    navigation: [{
        label: 'prems-discount-category.general.moduleTitle',
        color: '#FFD700',
        path: 'prems.discount.category.list',
        icon: 'regular-shopping-cart',
        parent: 'sw-marketing',
        position: 30
    }]
});
